<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2hnsTM/tc-custom/9781909166998.jpg?1698159288156" alt="This image is the cover for the book Victory Fighters: The Veterans' Story"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Victory Fighters: The Veterans' Story
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of eyewitness accounts of the struggle that raged in the skies over occupied Europe after the Battle of Britain during World War II.</b><br/><br/> Expertly selected and interwoven by Stephen Darlow, <i>Victory Fighters</i> centers on the stories of six pilots and one navigator, the telling of which covers every aspect of this battle over land and sea. The author describes and analyzes the relevant command decisions from the highest level down, and against this background the men give their accounts from the start of their flying careers through to the preparations for operation Overlord, the invasion itself, the liberation of France, the crossing of the Rhine, to the end of the war in Europe on VE-Day.<br/><br/> Through their eyes, the reader is introduced to a series of different tasks and situations, a multitude of aircraft types—Sunderlands, Mustangs, Tempests, Typhoons, Spitfires, Whirlwinds, Mosquitoes—and a great many squadrons.<br/><br/> Having conducted numerous interviews and undertaken diligent research of documents, diaries and correspondence, the author has produced a fitting testament to these men and the countless others they represent.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Darlow
      </h2>
      
      <p class="authorDescription body article">Steve Darlow is a Bomber Command historian and established military aviation author, with fourteen books to his name. Steve has made numerous radio and television appearances, and recently acted as program consultant on the BBC&rsquo;s The Lancaster: Britain&rsquo;s Flying Past and Channel 5&rsquo;s War Hero in the Family (Robert Llewelyn). Steve is also an Ambassador of the Royal Air Force Benevolent Fund.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?70e1896b